import { IndicatorNoId } from '@/entities/indicator';
import { Api } from './api/axios-config';
import { useIndicators } from '@/hook/useIndicators';

export class IndicatorService{
  private static api = Api();
 
  public static async getAllIndicator(){
    const response = await this.api.get<any>('/indicator');
    if(response.status === 200){
      return response.data.map((data:any)=>({
        id:data.id,
        name:data.name,
        phone:data.phone,
        commission:data.commission,
        email:data.email
      }));
    }
    return null;
  }

  public static async createIndicator(indicator:IndicatorNoId){
    const response = await this.api.post<any>('/indicator/create',{
      name: indicator.name,
      email: indicator.email,
      phone: indicator.phone,
      commission: indicator.commission
    });
    if(response.status === 201){
      return {
        id: response.data.id,
        name: response.data.name,
        email: response.data.email,
        phone: response.data.phone,
        commission: response.data.commission
      };
    }
    return null;
  }

  public static async updateIndicator(id:number, indicator:IndicatorNoId){
    const response = await this.api.post<any>(`/indicator/update/${id}`, {
      name: indicator.name,
      email: indicator.email,
      phone: indicator.phone,
      commission: indicator.commission
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async deleteIndicator(id: number) {
    try {
      const response = await this.api.delete<any>(`/indicator/delete/${id}`);
      // Verifica se a resposta foi bem-sucedida
      if (response.status === 200) {
        return {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
          phone: response.data.phone,
          commission: response.data.commission
        };
        
      }else {
        // Se a resposta não for 200, lance um erro
        throw new Error(`Erro ao deletar: ${response.statusText}`);
      }
    } catch (error) {
      // Capture erros de rede ou outros problemas
      if (error instanceof Error) {
        console.error('Erro ao deletar indicador:', error.message);
        throw new Error(error.message);
      } else {
        throw new Error('Erro desconhecido ao deletar indicador');
      }
    }
  }

  public static async searchIndicator(contains:string){
    const response = await this.api.get<any>(`/indicator/search/${contains}`);
    if(response.status === 200){
      return response.data.map((i:any)=>({
        id: i.id,
        name:i.name,
        phone: i.phone,
        email: i.email,
        commission: i.commission,
        createdAt: i.createdAt
      }));
    }
  }
  
}
